import { Store } from 'vuex';
// @ts-ignore
// import LoginAPI from '@ekd/login-api-client-v2/lt';

import getPortalLoginToken from '@root/modules/customer/utils/getPortalLoginToken';
import getCustomers from '@root/modules/customer/services/getCustomers';
interface LoginAPI extends Window {
  LoginAPI: any;
}

declare let window: LoginAPI;

export default async function listenToCustomerLoginState(store: Store<Record<string, unknown>>) {
  const isServer = typeof window === 'undefined';

  if (isServer) {
    return;
  }

  // FIX ME: Use login-api-client from nuxt.config until login-app refactor
  /*
  if (!isServer && !window.LoginAPI) {
    window.LoginAPI = LoginAPI;
  }
  */

  window.LoginAPI.on('login_api_login', ({ detail }: { detail: any }) => {
    store.dispatch('customer/setCustomerData', { data: detail });
  });

  window.LoginAPI.on('login_api_logout', () => store.dispatch('customer/logout'));

  window.LoginAPI.on('login_api_change', ({ detail }: { detail: any }) => {
    store.dispatch('customer/setCustomerData', { data: detail });
  });

  window.LoginAPI.on('login_api_init', (response: { detail: { loginStatus: any } }) => {
    if (!response.detail || !response.detail.loginStatus) {
      store.commit('customer/setLoggedInStatus', false);
      return;
    }

    store.dispatch('customer/setCustomerData', { data: response.detail });
  });

  const client = await getCustomers();

  // Fallback request if `login_api_init` is fired before listener has been set
  if (client.state === 'customerData') {
    if (client.data) {
      store.dispatch('customer/setCustomerData', { data: client.data });
    } else {
      store.commit('customer/setLoggedInStatus', false);
    }
  } else if (client.state === 'noToken') {
    store.commit('customer/setLoggedInStatus', false);
  } else if (client.state === 'clientNotInited') {
    // Try to log user in as a last resort
    // This check is fired when login-api is down or when login-api-client is not loaded
    const token = getPortalLoginToken();
    store.commit('customer/setLoggedInStatus', !!token);
    store.commit('customer/setToken', token || null);
  }
}
